<script>
//See if we can factor this out and use ValueStorage instead.
    import {Money} from 'v-money'
    import {currencySymbol} from "../../mixins/currency";


    export default {
        name: "html-charity",
        components: {Money},
        mixins: [currencySymbol],
        props: {
            charity: {
                type: Object,
                default: () => ({}),
                required: true
            },
        },
        data() {
            return {
                amountSelected: 0,
                customAmount: 0,
                currency: this.charity.currency,
                money: {
                    decimal: '.',
                    thousands: ',',
                    prefix: this.convertCurrencyCodeToPrefix(this.charity.currency),
                    suffix: '',
                    precision: 2,
                    masked: false
                }
            }
        },
        created() {
            this.setAmounts();
        },
        computed: {
            amount() {
                return this.amountSelected === "other" ?
                    this.customAmount * 100
                    : parseInt(this.amountSelected);
            },
        },
        watch: {
            amountSelected: function (val) {
                if (val !== 'other') {
                    this.customAmount = 0;
                }
            }
        },
        methods: {
            setAmounts() {
                if (this.charity.hasOwnProperty('donation') && this.charity.donation !== null && this.charity.hasOwnProperty('fixed_donation_amounts') && this.charity.fixed_donation_amounts !== null) {
                    var fixedAmounts = Object.entries(this.charity.fixed_donation_amounts).map(x => parseInt(x[1].amount));

                    if (fixedAmounts.indexOf(this.charity.donation.amount) > -1) {
                        this.amountSelected = this.charity.donation.amount
                    } else {
                        this.amountSelected = "other";
                        this.customAmount = this.charity.donation.custom_amount;
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/Assets/components/AAA_TO_REFACTOR/HtmlCharity.vue